/* ═══════════════════════════════════════════════════════════════════════════
   THE NAIL LAB — site motion
   Lenis smooth scroll + GSAP ScrollTrigger reveals/parallax + the hero canvas
   scrubber. Everything degrades gracefully: if a library fails to load or the
   visitor prefers reduced motion, content is simply shown.
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasGsap = typeof window.gsap !== "undefined" && typeof window.ScrollTrigger !== "undefined";
  // Touch-first devices keep native scrolling (Lenis adds nothing there and can fight iOS momentum).
  var touchDevice = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
  // Inside the Shopify theme editor the editor scrolls the preview itself; Lenis fights it and the
  // preview "sticks". Native scrolling there, smooth scrolling on the live site.
  var inEditor = !!(window.Shopify && window.Shopify.designMode);
  var hasLenis = typeof window.Lenis !== "undefined" && !touchDevice && !inEditor;

  /* ── Header state ───────────────────────────────────────────────────────── */
  var header = document.querySelector(".nl-header");
  function onScrollHeader() {
    if (!header) return;
    header.classList.toggle("is-scrolled", window.scrollY > 24);
  }
  window.addEventListener("scroll", onScrollHeader, { passive: true });
  onScrollHeader();

  /* ── Mobile menu drawer ─────────────────────────────────────────────────── */
  (function menu() {
    var drawer = document.querySelector("[data-menu]");
    var openBtn = document.querySelector("[data-menu-open]");
    if (!drawer || !openBtn) return;
    function open() {
      drawer.hidden = false; openBtn.setAttribute("aria-expanded", "true");
      document.body.style.overflow = "hidden";
      if (window.__lenis) window.__lenis.stop();
      var c = drawer.querySelector("[data-menu-close]"); if (c) c.focus();
    }
    function close() {
      drawer.hidden = true; openBtn.setAttribute("aria-expanded", "false");
      document.body.style.overflow = "";
      if (window.__lenis) window.__lenis.start();
      openBtn.focus();
    }
    openBtn.addEventListener("click", open);
    drawer.querySelectorAll("[data-menu-close], [data-menu-link]").forEach(function (el) { el.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (!drawer.hidden && e.key === "Escape") close(); });
    window.__nlMenuClose = close;
  })();

  /* ── Gallery rail: arrows, drag, wheel→horizontal, counter, lightbox ──── */
  (function gallery() {
    var root = document.querySelector("[data-gallery]");
    if (!root) return;
    var rail = root.querySelector("[data-gallery-rail]");
    var items = Array.prototype.slice.call(rail.querySelectorAll(".nl-rail__item"));
    var openers = Array.prototype.slice.call(rail.querySelectorAll("[data-gallery-open]"));
    var prev = root.querySelector("[data-gallery-prev]");
    var next = root.querySelector("[data-gallery-next]");
    var cur = root.querySelector("[data-gallery-current]");
    var tot = root.querySelector("[data-gallery-total]");
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    if (tot) tot.textContent = pad(items.length);

    function step() { return items[0] ? items[0].getBoundingClientRect().width + 20 : 300; }
    function indexAt() {
      var x = rail.scrollLeft + 8, i = 0;
      for (var k = 0; k < items.length; k++) { if (items[k].offsetLeft - rail.offsetLeft <= x) i = k; }
      return i;
    }
    function updateCount() {
      if (cur) cur.textContent = pad(indexAt() + 1);
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    }
    rail.addEventListener("scroll", updateCount, { passive: true });
    window.addEventListener("resize", updateCount);
    updateCount();

    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step() * 2, behavior: "smooth" }); });

    // Trackpad horizontal swipes scroll the rail natively (data-lenis-prevent keeps Lenis out);
    // vertical wheel keeps scrolling the page so nobody gets "stuck" in the gallery.

    // Drag to scroll with a mouse.
    var down = false, startX = 0, startLeft = 0, moved = 0;
    rail.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      down = true; moved = 0; startX = e.clientX; startLeft = rail.scrollLeft;
      rail.setPointerCapture(e.pointerId);
    });
    rail.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx));
      if (moved > 4) rail.classList.add("is-dragging");
      rail.scrollLeft = startLeft - dx;
    });
    function up() { if (!down) return; down = false; setTimeout(function () { rail.classList.remove("is-dragging"); }, 50); }
    rail.addEventListener("pointerup", up); rail.addEventListener("pointercancel", up); rail.addEventListener("pointerleave", up);
    rail.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { rail.scrollBy({ left: step(), behavior: "smooth" }); e.preventDefault(); }
      if (e.key === "ArrowLeft") { rail.scrollBy({ left: -step(), behavior: "smooth" }); e.preventDefault(); }
    });

    // Lightbox
    var lb = root.querySelector("[data-lightbox]");
    if (!lb || !openers.length) return;
    var lbImg = lb.querySelector("[data-lightbox-img]");
    var lbCap = lb.querySelector("[data-lightbox-cap]");
    var current = 0, lastFocus = null;
    function show(i) {
      current = (i + openers.length) % openers.length;
      var o = openers[current];
      lbImg.src = o.getAttribute("data-full");
      lbImg.alt = o.getAttribute("data-caption") || "";
      lbCap.textContent = o.getAttribute("data-caption") || "";
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i); lb.hidden = false; document.body.style.overflow = "hidden";
      if (window.__lenis) window.__lenis.stop();
      lb.querySelector("[data-lightbox-close]").focus();
    }
    function close() {
      lb.hidden = true; document.body.style.overflow = "";
      if (window.__lenis) window.__lenis.start();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (o, i) { o.addEventListener("click", function () { if (moved > 4) return; open(i); }); });
    lb.querySelector("[data-lightbox-close]").addEventListener("click", close);
    lb.querySelector("[data-lightbox-prev]").addEventListener("click", function () { show(current - 1); });
    lb.querySelector("[data-lightbox-next]").addEventListener("click", function () { show(current + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb) close(); });
    document.addEventListener("keydown", function (e) {
      if (lb.hidden) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") show(current + 1);
      if (e.key === "ArrowLeft") show(current - 1);
    });
    // Swipe inside the lightbox on touch.
    var tx = null;
    lb.addEventListener("touchstart", function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener("touchend", function (e) {
      if (tx === null) return; var dx = e.changedTouches[0].clientX - tx; tx = null;
      if (dx < -40) show(current + 1); else if (dx > 40) show(current - 1);
    });
  })();

  /* ── Reveal everything immediately if motion is off / libs missing ─────── */
  function showAll() {
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      el.style.opacity = "1";
      el.style.transform = "none";
    });
  }
  if (reduce || !hasGsap) {
    showAll();
    document.querySelectorAll("svg[data-draw]").forEach(function (s) { s.classList.add("is-drawn"); s.querySelectorAll("path, ellipse, circle").forEach(function (p) { p.style.strokeDasharray = "none"; }); });
    if (window.NLHero) window.NLHero.init({ reduce: true });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  /* ── Touch devices: sections marked [data-touch-static] get no scroll motion.
        The price lists (Services / Pedicures) felt sticky to scroll on phones
        with dozens of reveal tweens + a floating molecule, so they render
        static there and keep their animations on desktop. ────────────────── */
  // Treat anything touch-capable OR phone-width as "mobile" here, so the static
  // list doesn't hinge on a single media query some browsers report oddly.
  var mobileLike = touchDevice || (navigator.maxTouchPoints || 0) > 0 || window.innerWidth < 900;
  var staticRoots = mobileLike ? Array.prototype.slice.call(document.querySelectorAll("[data-touch-static]")) : [];
  function isStatic(el) {
    for (var i = 0; i < staticRoots.length; i++) if (staticRoots[i].contains(el)) return true;
    return false;
  }
  staticRoots.forEach(function (root) {
    root.querySelectorAll("[data-reveal]").forEach(function (el) { el.style.opacity = "1"; el.style.transform = "none"; });
    root.querySelectorAll("svg[data-draw]").forEach(function (s) {
      s.classList.add("is-drawn");
      s.querySelectorAll("path, ellipse, circle").forEach(function (p) { p.style.strokeDasharray = "none"; p.style.strokeDashoffset = "0"; });
    });
  });

  /* ── Lenis smooth scroll, driven by GSAP's ticker ───────────────────────── */
  var lenis = null;
  if (hasLenis) {
    lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, smoothWheel: true });
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
    window.__lenis = lenis;

  }

  // Smooth anchor links (/#gallery etc.) — also from the mobile drawer. Works with or without Lenis.
  document.querySelectorAll('a[href^="#"], a[href^="/#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").replace(/^\/?#/, "");
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      if (window.__nlMenuClose) window.__nlMenuClose();
      setTimeout(function () {
        if (lenis) lenis.scrollTo(target, { offset: -8, duration: 1.4 });
        else target.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 30);
    });
  });

  /* ── Scroll-triggered reveals ───────────────────────────────────────────── */
  // Elements inside the same [data-reveal-group] stagger; others reveal alone.
  var grouped = new Set();
  document.querySelectorAll("[data-reveal-group]").forEach(function (group) {
    var items = group.querySelectorAll("[data-reveal]");
    items.forEach(function (i) { grouped.add(i); });
    if (isStatic(group)) return;
    gsap.to(items, {
      opacity: 1, y: 0, scale: 1, duration: 1.4, ease: "expo.out", stagger: 0.09,
      scrollTrigger: { trigger: group, start: "top 85%", once: true }
    });
  });
  document.querySelectorAll("[data-reveal]").forEach(function (el) {
    if (grouped.has(el) || isStatic(el)) return;
    gsap.to(el, {
      opacity: 1, y: 0, scale: 1, duration: 1.4, ease: "expo.out",
      scrollTrigger: { trigger: el, start: "top 88%", once: true }
    });
  });

  /* ── Subtle parallax on .px images ──────────────────────────────────────── */
  document.querySelectorAll(".px > img").forEach(function (img) {
    gsap.fromTo(img, { yPercent: -9 }, {
      yPercent: 9, ease: "none",
      scrollTrigger: { trigger: img.parentElement, start: "top bottom", end: "bottom top", scrub: true }
    });
  });

  /* ── Lab elements: line-draw molecules on reveal, gentle float ─────────── */
  document.querySelectorAll("svg[data-draw]").forEach(function (svg) {
    if (isStatic(svg)) return;
    var strokes = svg.querySelectorAll("path, ellipse, circle");
    strokes.forEach(function (el) {
      var len = 0;
      try { len = el.getTotalLength ? el.getTotalLength() : 0; } catch (e) { len = 0; }
      if (!len) len = 200;
      el.style.strokeDasharray = len;
      el.style.strokeDashoffset = len;
    });
    gsap.to(strokes, {
      strokeDashoffset: 0, duration: 1.6, ease: "power2.inOut", stagger: 0.08,
      scrollTrigger: { trigger: svg, start: "top 90%", once: true },
      onStart: function () { svg.classList.add("is-drawn"); }
    });
  });
  document.querySelectorAll("[data-float]").forEach(function (el, i) {
    if (isStatic(el)) return;
    gsap.to(el, { y: i % 2 ? -10 : 10, rotation: i % 2 ? -1.2 : 1.2, duration: 5 + (i % 3), ease: "sine.inOut", yoyo: true, repeat: -1 });
  });

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  if (window.NLHero) window.NLHero.init({ reduce: false, lenis: lenis });

  // Recalculate after fonts/images settle, and whenever the theme editor re-renders a section.
  window.addEventListener("load", function () { ScrollTrigger.refresh(); });
  ["shopify:section:load", "shopify:section:reorder", "shopify:section:select"].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(function () { ScrollTrigger.refresh(); }, 100); });
  });
})();
